import { 
  CaseStatusEnum, 
  CaseTaskEnum, 
  ICaseDetailsModel, 
  ICaseTaskModel, 
  TaskStatusEnum 
} from "../../../models/Cases/CaseDetailsModel"
import TaskItem from "./TaskItem";
import CreateTaskIcon from "../../../images/create-task.svg";
import { Accordion } from "react-bootstrap";
import { useEffect, useState } from "react";
import { catchError } from "../../../utils/Utils";
import { AxiosResponse } from "axios";

interface ICaseTasksContainerProps {
  caseDetails: ICaseDetailsModel | null;
  toggleCaseTaskModal: () => void;
  setSelectedTask: (value: ICaseTaskModel | null) => void;
  selectedTask: ICaseTaskModel | null;
  getCaseTaskByTaskId: (id: string) => Promise<AxiosResponse<any, any> | undefined>;
  accordianOpen: string | null
  setAccordianOpen: (value: string | null) => void;
  verifyTask: (values: any, init?: boolean) => Promise<void>
}

const CaseTasksContainer = (props: ICaseTasksContainerProps) => {
  const { 
    caseDetails, 
    toggleCaseTaskModal, 
    selectedTask, 
    setSelectedTask, 
    getCaseTaskByTaskId,
    accordianOpen,
    setAccordianOpen,
    verifyTask
  } = props;
  const [kickOffTask, setKickOffTask] = useState<ICaseTaskModel | null>();
  const [closingTask, setClosingTask] = useState<ICaseTaskModel | null>();
  const [allTasks, setAllTasks] = useState<ICaseTaskModel[]>([]);

  const resetAllTasks = () => {
    setKickOffTask(null)
    setClosingTask(null)
    setAllTasks([])
  } 

  const sortTasks = () => {
    resetAllTasks();
    caseDetails?.caseTask?.forEach(each => {
      if (each?.type === CaseTaskEnum.KICK_OFF_TASK) {
        setKickOffTask(each)
      } else if (each?.type === CaseTaskEnum.CLOSING_TASK) {
        setClosingTask(each)
      } else {
        setAllTasks(prev => [...prev, each])
      }
    })
  }

  useEffect(() => {
    sortTasks();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [caseDetails?.caseTask])

  const accordianSelect = async (e: any) => {
    if (e) {
      try {
        const taskResult = await getCaseTaskByTaskId(e);
        setSelectedTask(taskResult?.data);
        if (taskResult?.data?.status === TaskStatusEnum.INACTIVE) {
          toggleCaseTaskModal();
        } else setAccordianOpen(e);
      } catch (err) {
        catchError(err, true);
      }
    } else {
      setAccordianOpen(e)
      setSelectedTask(e);
    }
  }

  const createTaskClick = () => {
    setAccordianOpen(null)
    setSelectedTask(null);
    toggleCaseTaskModal && toggleCaseTaskModal()
  }
  
  const getCaseTaskDetails = async (taskId: string) => {
    try {
      const taskResult = await getCaseTaskByTaskId(taskId);
      setSelectedTask(taskResult?.data);
    } catch (err) {
      catchError(err, true);
    }
  }

  return (
    <div className="caseTaskContainer">
      {/* Main title */}
      <div className="caseTaskHeader">
        <div className="caseTaskTitle">
          Case Tasks { caseDetails && caseDetails?.caseTask?.length > 2 ? `(${caseDetails?.caseTask?.length})` : '' }
        </div>
        {
            caseDetails?.status !== CaseStatusEnum.READY_FOR_REVIEW &&
            caseDetails?.status !== CaseStatusEnum.SUBMITTED &&
            caseDetails?.status !== CaseStatusEnum.ARCHIVED ?
          
        <button 
          className="createTaskButton" 
          onClick={() => createTaskClick()}
        >
          <img src={CreateTaskIcon} alt="CreateTaskIcon" /> <span className="btn-text">Create New Task</span>
        </button>:''}
      </div>

      {/* Task main container */}
      <div className="taskMainContainer">
        <Accordion 
          className="tasksAccordion"
          activeKey={`${accordianOpen || null}`}
          onSelect={(e: any) => accordianSelect(e)}
        >
        {/* Kick off Task container */}
        <div className="taskContainer kickOff">
          <div className="taskContainerTitle">Kick off Task</div>
          <div className="taskContainerInner">
            { kickOffTask ? 
                <TaskItem 
                  task={kickOffTask} 
                  toggleCaseTaskModal={toggleCaseTaskModal} 
                  selectedTask={selectedTask}
                  getCaseTaskByTaskId={getCaseTaskDetails}
                  caseDetails={caseDetails}
                  verifyTask={verifyTask}
                /> : 
                <h6 className="not-available">No Tasks Available</h6>
            }
          </div>
        </div>

        {/* Task container */}
        <div className="taskContainer tasks">
          <div className="taskContainerInner">
            { allTasks?.map(each => 
              <TaskItem 
                key={each?.taskId} 
                task={each} 
                toggleCaseTaskModal={toggleCaseTaskModal} 
                selectedTask={selectedTask}
                getCaseTaskByTaskId={getCaseTaskDetails}
                caseDetails={caseDetails}
                verifyTask={verifyTask}
              />
            )
            }
          </div>
        </div>

        {/* Closing Task container */}
        <div className="taskContainer closing">
          <div className="taskContainerTitle">Closing Task</div>
          <div className="taskContainerInner">
            { closingTask ? 
                <TaskItem 
                  task={closingTask} 
                  toggleCaseTaskModal={toggleCaseTaskModal}
                  selectedTask={selectedTask}
                  getCaseTaskByTaskId={getCaseTaskDetails}
                  caseDetails={caseDetails}
                  verifyTask={verifyTask}
                /> : 
                <h6 className="not-available">No Tasks Available</h6>
            }
          </div>
        </div>
        </Accordion>
      </div>
    </div>
  )
}

export default CaseTasksContainer